import axios from "axios";
import Config from "../../../config/index";
import {
    GET_UPLOAD_ERRORS_REQUEST,
    GET_UPLOAD_ERRORS_SUCCESS,
    GET_UPLOAD_ERRORS_FAILURE,
} from "./uploadTableTypes";

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;






const getUploadErrorsRequest = () => ({
    type: GET_UPLOAD_ERRORS_REQUEST,
});

const getUploadErrorsSuccess = (payload) => ({
    type: GET_UPLOAD_ERRORS_SUCCESS,
    payload: payload,
});

const getUploadErrorsFailure = (error) => ({
    type: GET_UPLOAD_ERRORS_FAILURE,
    payload: error,
});

const getUploadErrors = (jwtToken) => {
    let headers = {
        headers: { Authorization: `Bearer ${jwtToken}` },
    };
    return (dispatch) => {
        dispatch(getUploadErrorsRequest());
        let url = `${baseUrlFileUploadTemp}/reports/upload_errors`;
        return axios
            .get(url, headers)
            .then((response) => {
                dispatch(getUploadErrorsSuccess(response.data));
                return { status: true, data: response.data };
            })
            .catch((err) => {
                dispatch(getUploadErrorsFailure(err.response));
                return { status: false, data: err.response };
            });
    };
};


export { getUploadErrors }